import _slicedToArray from "/codebuild/output/src987384395/src/Centrum-React-App/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/codebuild/output/src987384395/src/Centrum-React-App/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { AsYouType } from 'libphonenumber-js/min/index';
/**
 * Headless phone number input formatter.
 */

function PhoneFormatter(_ref) {
  var onChange = _ref.onChange,
      defaultCountry = _ref.defaultCountry,
      props = _objectWithoutProperties(_ref, ["onChange", "defaultCountry"]);

  var _a;

  var _React$useState = React.useState(""),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      inputValue = _React$useState2[0],
      setInputValue = _React$useState2[1];

  var _React$useState3 = React.useState(function () {
    return new AsYouType(defaultCountry);
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 1),
      formatter = _React$useState4[0];

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      impossible = _React$useState6[0],
      setImpossible = _React$useState6[1];

  var onInputChange = function onInputChange(newValue) {
    if (inputValue == newValue) return; // The as-you-type formatter only works with append-only inputs.
    // Changes other than append require a reset.

    var isAppend = newValue.length > inputValue.length && newValue.slice(0, inputValue.length) == inputValue;

    if (isAppend) {
      var appended = newValue.slice(inputValue.length);
      setInputValue(formatter.input(appended));
    } else {
      // Reset the formatter, but do not reformat.
      // Doing so now will cause the user to loose their cursor position
      // Wait until blur or append to reformat.
      formatter.reset();
      formatter.input(newValue);
      setInputValue(newValue);
    }

    var number = formatter.getNumber();
    var e164 = number === null || number === void 0 ? void 0 : number.number;
    onChange(e164);
    if (impossible && number && number.isPossible()) setImpossible(false);
  };

  React.useLayoutEffect(function () {
    var _a;

    var number = (_a = formatter.getNumber()) === null || _a === void 0 ? void 0 : _a.number;

    if (number != props.value) {
      // override the phone number if the field has a number and its e164 representation doesn't match the prop value.
      formatter.reset();
      setInputValue(props.value ? formatter.input(props.value) : "");

      var _number = formatter.getNumber();

      setImpossible(_number == null ? null : !_number.isPossible());
      var e164 = _number === null || _number === void 0 ? void 0 : _number.number;
      onChange(e164);
    }
  }, [props.value, formatter, inputValue, onChange]);
  var country = (_a = formatter.getNumber()) === null || _a === void 0 ? void 0 : _a.country;
  return React.createElement(React.Fragment, null, props.children({
    country: country,
    impossible: impossible,
    inputValue: inputValue,
    onInputChange: onInputChange,
    onBlur: function onBlur() {
      var number = formatter.getNumber();
      onChange(number === null || number === void 0 ? void 0 : number.number);
      if (!number) return setImpossible(null); // Check and update possibility

      var possible = number.isPossible();
      setImpossible(!possible);

      if (possible) {
        // Reformat the phone number as international
        formatter.reset();
        setInputValue(formatter.input(number.number));
      } else {
        // Format the phone number
        setInputValue(formatter.input(""));
      }
    }
  }));
}

export default PhoneFormatter;